import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { VdpElement } from '../../types';
import { 
  Lock, Unlock, Copy, Trash2, ArrowUp, ArrowDown, Maximize2, GripVertical, Pin, PinOff, RotateCcw, FolderPlus, FolderMinus
} from 'lucide-react';

const AlignLeftIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="3" y1="2" x2="3" y2="22" strokeWidth="2.5" />
    <rect x="3" y="5" width="14" height="5" rx="1" fill="currentColor" fillOpacity="0.25" />
    <rect x="3" y="14" width="9" height="5" rx="1" fill="currentColor" fillOpacity="0.25" />
  </svg>
);

const AlignCenterHIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="2" x2="12" y2="22" strokeDasharray="2 2" strokeWidth="1.5" />
    <rect x="5" y="5" width="14" height="5" rx="1" fill="currentColor" fillOpacity="0.25" />
    <rect x="8" y="14" width="8" height="5" rx="1" fill="currentColor" fillOpacity="0.25" />
  </svg>
);

const AlignRightIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="21" y1="2" x2="21" y2="22" strokeWidth="2.5" />
    <rect x="7" y="5" width="14" height="5" rx="1" fill="currentColor" fillOpacity="0.25" />
    <rect x="12" y="14" width="9" height="5" rx="1" fill="currentColor" fillOpacity="0.25" />
  </svg>
);

const AlignTopIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="2" y1="3" x2="22" y2="3" strokeWidth="2.5" />
    <rect x="5" y="3" width="5" height="14" rx="1" fill="currentColor" fillOpacity="0.25" />
    <rect x="14" y="3" width="5" height="9" rx="1" fill="currentColor" fillOpacity="0.25" />
  </svg>
);

const AlignMiddleVIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="2" y1="12" x2="22" y2="12" strokeDasharray="2 2" strokeWidth="1.5" />
    <rect x="5" y="5" width="5" height="14" rx="1" fill="currentColor" fillOpacity="0.25" />
    <rect x="14" y="8" width="5" height="8" rx="1" fill="currentColor" fillOpacity="0.25" />
  </svg>
);

const AlignBottomIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="2" y1="21" x2="22" y2="21" strokeWidth="2.5" />
    <rect x="5" y="7" width="5" height="14" rx="1" fill="currentColor" fillOpacity="0.25" />
    <rect x="14" y="12" width="5" height="9" rx="1" fill="currentColor" fillOpacity="0.25" />
  </svg>
);

const DistributeTopIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.5H13V2.5H1V1.5ZM3 4.5H6V11.5H3V4.5ZM8 4.5H11V8.5H8V4.5Z" fill="currentColor"/>
  </svg>
);
const DistributeCenterVIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 6.5H13V7.5H1V6.5ZM3 2H6V12H3V2ZM8 3.5H11V10.5H8V3.5Z" fill="currentColor" fillOpacity="0.5"/>
    <path d="M1 6.5H13V7.5H1V6.5Z" fill="currentColor"/>
  </svg>
);
const DistributeBottomIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 11.5H13V12.5H1V11.5ZM3 2.5H6V9.5H3V2.5ZM8 5.5H11V9.5H8V5.5Z" fill="currentColor"/>
  </svg>
);
const DistributeLeftIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 1V13H2.5V1H1.5ZM4.5 3H11.5V6H4.5V3ZM4.5 8H8.5V11H4.5V8Z" fill="currentColor"/>
  </svg>
);
const DistributeCenterHIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 1V13H7.5V1H6.5ZM2 3H12V6H2V3ZM3.5 8H10.5V11H3.5V8Z" fill="currentColor" fillOpacity="0.5"/>
    <path d="M6.5 1V13H7.5V1H6.5Z" fill="currentColor"/>
  </svg>
);
const DistributeRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 1V13H12.5V1H11.5ZM2.5 3H9.5V6H2.5V3ZM5.5 8H9.5V11H5.5V8Z" fill="currentColor"/>
  </svg>
);
const DistributeSpacingVIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.5H13V2.5H1V1.5ZM1 11.5H13V12.5H1V11.5ZM3 4H11V9.5H3V4Z" fill="currentColor"/>
  </svg>
);
const DistributeSpacingHIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 1V13H2.5V1H1.5ZM11.5 1V13H12.5V1H11.5ZM4 3H9.5V11H4V3Z" fill="currentColor"/>
  </svg>
);

export interface CanvasAlignmentToolbarProps {
  selectedElements: VdpElement[];
  canvasWidth: number;
  canvasHeight: number;
  onBatchUpdateElements: (updatesMap: Record<string, Partial<VdpElement>>) => void;
  onDuplicateSelected?: () => void;
  onDeleteSelected?: () => void;
  onMoveLayerUp?: () => void;
  onMoveLayerDown?: () => void;
  onToggleLockSelected?: () => void;
  onGroupSelected?: () => void;
  onUngroupSelected?: () => void;
}

export const TopAlignmentToolbar: React.FC<CanvasAlignmentToolbarProps> = React.memo(({
  selectedElements,
  canvasWidth,
  canvasHeight,
  onBatchUpdateElements,
  onGroupSelected,
  onUngroupSelected
}) => {
  const [alignMode, setAlignMode] = useState<'selection' | 'canvas'>('selection');

  if (selectedElements.length === 0) return null;

  const targetMode = selectedElements.length === 1 ? 'canvas' : alignMode;
  const cWidth = canvasWidth || 300;
  const cHeight = canvasHeight || 200;

  const handleAlignLeft = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => { updatesMap[el.id] = { x: 0 }; });
    } else {
      const minX = Math.min(...selectedElements.map(e => e.x));
      selectedElements.forEach(el => { updatesMap[el.id] = { x: minX }; });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignCenterH = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => {
        const w = el.width || 100;
        updatesMap[el.id] = { x: Math.round((cWidth - w) / 2) };
      });
    } else {
      const minX = Math.min(...selectedElements.map(e => e.x));
      const maxX = Math.max(...selectedElements.map(e => e.x + (e.width || 100)));
      const centerX = minX + (maxX - minX) / 2;
      selectedElements.forEach(el => {
        const w = el.width || 100;
        updatesMap[el.id] = { x: Math.round(centerX - w / 2) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignRight = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => {
        const w = el.width || 100;
        updatesMap[el.id] = { x: Math.round(cWidth - w) };
      });
    } else {
      const maxX = Math.max(...selectedElements.map(e => e.x + (e.width || 100)));
      selectedElements.forEach(el => {
        const w = el.width || 100;
        updatesMap[el.id] = { x: Math.round(maxX - w) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignTop = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => { updatesMap[el.id] = { y: 0 }; });
    } else {
      const minY = Math.min(...selectedElements.map(e => e.y));
      selectedElements.forEach(el => { updatesMap[el.id] = { y: minY }; });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignMiddleV = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => {
        const h = el.height || 100;
        updatesMap[el.id] = { y: Math.round((cHeight - h) / 2) };
      });
    } else {
      const minY = Math.min(...selectedElements.map(e => e.y));
      const maxY = Math.max(...selectedElements.map(e => e.y + (e.height || 100)));
      const centerY = minY + (maxY - minY) / 2;
      selectedElements.forEach(el => {
        const h = el.height || 100;
        updatesMap[el.id] = { y: Math.round(centerY - h / 2) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignBottom = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => {
        const h = el.height || 100;
        updatesMap[el.id] = { y: Math.round(cHeight - h) };
      });
    } else {
      const maxY = Math.max(...selectedElements.map(e => e.y + (e.height || 100)));
      selectedElements.forEach(el => {
        const h = el.height || 100;
        updatesMap[el.id] = { y: Math.round(maxY - h) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleDistributeH = () => {
    const sorted = [...selectedElements].sort((a, b) => a.x - b.x);
    const updatesMap: Record<string, Partial<VdpElement>> = {};

    if (targetMode === 'canvas') {
      const sumWidth = sorted.reduce((acc, el) => acc + (el.width || 100), 0);
      const freeSpace = cWidth - sumWidth;
      const gap = freeSpace / (sorted.length + 1);
      let currX = gap;
      sorted.forEach(el => {
        updatesMap[el.id] = { x: Math.round(currX) };
        currX += (el.width || 100) + gap;
      });
    } else {
      if (sorted.length < 2) return;
      const minX = sorted[0].x;
      const maxRight = sorted[sorted.length - 1].x + (sorted[sorted.length - 1].width || 100);
      const sumWidth = sorted.reduce((acc, el) => acc + (el.width || 100), 0);
      const freeSpace = (maxRight - minX) - sumWidth;
      const gap = freeSpace / (sorted.length - 1);
      let currX = minX;
      sorted.forEach((el, idx) => {
        if (idx === 0) updatesMap[el.id] = { x: minX };
        else if (idx === sorted.length - 1) updatesMap[el.id] = { x: maxRight - (el.width || 100) };
        else updatesMap[el.id] = { x: Math.round(currX) };
        currX += (el.width || 100) + gap;
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleDistributeV = () => {
    const sorted = [...selectedElements].sort((a, b) => a.y - b.y);
    const updatesMap: Record<string, Partial<VdpElement>> = {};

    if (targetMode === 'canvas') {
      const sumHeight = sorted.reduce((acc, el) => acc + (el.height || 100), 0);
      const freeSpace = cHeight - sumHeight;
      const gap = freeSpace / (sorted.length + 1);
      let currY = gap;
      sorted.forEach(el => {
        updatesMap[el.id] = { y: Math.round(currY) };
        currY += (el.height || 100) + gap;
      });
    } else {
      if (sorted.length < 2) return;
      const minY = sorted[0].y;
      const maxBottom = sorted[sorted.length - 1].y + (sorted[sorted.length - 1].height || 100);
      const sumHeight = sorted.reduce((acc, el) => acc + (el.height || 100), 0);
      const freeSpace = (maxBottom - minY) - sumHeight;
      const gap = freeSpace / (sorted.length - 1);
      let currY = minY;
      sorted.forEach((el, idx) => {
        if (idx === 0) updatesMap[el.id] = { y: minY };
        else if (idx === sorted.length - 1) updatesMap[el.id] = { y: maxBottom - (el.height || 100) };
        else updatesMap[el.id] = { y: Math.round(currY) };
        currY += (el.height || 100) + gap;
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleCenterCanvasBoth = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (selectedElements.length === 1) {
      const el = selectedElements[0];
      const w = el.width || 100;
      const h = el.height || 100;
      updatesMap[el.id] = {
        x: Math.round((cWidth - w) / 2),
        y: Math.round((cHeight - h) / 2)
      };
    } else {
      const minX = Math.min(...selectedElements.map(e => e.x));
      const maxX = Math.max(...selectedElements.map(e => e.x + (e.width || 100)));
      const minY = Math.min(...selectedElements.map(e => e.y));
      const maxY = Math.max(...selectedElements.map(e => e.y + (e.height || 100)));

      const groupW = maxX - minX;
      const groupH = maxY - minY;
      const targetMinX = (cWidth - groupW) / 2;
      const targetMinY = (cHeight - groupH) / 2;
      const dx = targetMinX - minX;
      const dy = targetMinY - minY;

      selectedElements.forEach(el => {
        updatesMap[el.id] = {
          x: Math.round(el.x + dx),
          y: Math.round(el.y + dy)
        };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  return (
    <div className="bg-zinc-900/95 border-b border-zinc-800 px-3 py-1.5 flex flex-wrap items-center justify-between gap-2 z-20 text-xs text-zinc-200 select-none animate-in fade-in duration-150">
      <div className="flex items-center gap-2 flex-wrap">
        {/* Selection Badge */}
        <div className="flex items-center gap-1.5 px-2 py-0.5 rounded bg-blue-500/10 text-blue-400 border border-blue-500/20 font-medium text-[11px]">
          <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse" />
          <span>{selectedElements.length} {selectedElements.length === 1 ? 'element selected' : 'elements selected'}</span>
        </div>

        <div className="h-4 w-[1px] bg-zinc-800" />

        {/* Align Mode Toggle (Selection vs Canvas) */}
        {selectedElements.length > 1 && (
          <div className="flex items-center bg-zinc-950 border border-zinc-800 rounded p-0.5 text-[11px]">
            <button
              onClick={() => setAlignMode('selection')}
              className={`px-2 py-0.5 rounded font-medium transition-colors ${
                alignMode === 'selection' ? 'bg-blue-600 text-white' : 'text-zinc-400 hover:text-zinc-200'
              }`}
              title="Align relative to selected elements bounding box"
            >
              Align to Selection
            </button>
            <button
              onClick={() => setAlignMode('canvas')}
              className={`px-2 py-0.5 rounded font-medium transition-colors ${
                alignMode === 'canvas' ? 'bg-blue-600 text-white' : 'text-zinc-400 hover:text-zinc-200'
              }`}
              title="Align relative to full canvas page"
            >
              Align to Canvas
            </button>
          </div>
        )}

        <div className="h-4 w-[1px] bg-zinc-800" />

        {/* Quick Alignment Action Buttons */}
        <div className="flex items-center gap-0.5 bg-zinc-950 p-0.5 rounded border border-zinc-800">
          <button
            onClick={handleAlignLeft}
            className="p-1.5 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors flex items-center gap-1"
            title="Align Left Edges"
          >
            <AlignLeftIcon />
            <span className="hidden xl:inline text-[10px] font-medium">Left</span>
          </button>
          <button
            onClick={handleAlignCenterH}
            className="p-1.5 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors flex items-center gap-1"
            title="Align Center Horizontally"
          >
            <AlignCenterHIcon />
            <span className="hidden xl:inline text-[10px] font-medium">Center</span>
          </button>
          <button
            onClick={handleAlignRight}
            className="p-1.5 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors flex items-center gap-1"
            title="Align Right Edges"
          >
            <AlignRightIcon />
            <span className="hidden xl:inline text-[10px] font-medium">Right</span>
          </button>

          <div className="h-3 w-[1px] bg-zinc-800 mx-0.5" />

          <button
            onClick={handleAlignTop}
            className="p-1.5 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors flex items-center gap-1"
            title="Align Top Edges"
          >
            <AlignTopIcon />
            <span className="hidden xl:inline text-[10px] font-medium">Top</span>
          </button>
          <button
            onClick={handleAlignMiddleV}
            className="p-1.5 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors flex items-center gap-1"
            title="Align Middle Vertically"
          >
            <AlignMiddleVIcon />
            <span className="hidden xl:inline text-[10px] font-medium">Middle</span>
          </button>
          <button
            onClick={handleAlignBottom}
            className="p-1.5 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors flex items-center gap-1"
            title="Align Bottom Edges"
          >
            <AlignBottomIcon />
            <span className="hidden xl:inline text-[10px] font-medium">Bottom</span>
          </button>
        </div>

        {/* Distribute Buttons */}
        {selectedElements.length >= 2 && (
          <>
            <div className="h-4 w-[1px] bg-zinc-800" />
            <div className="flex items-center gap-0.5 bg-zinc-950 p-0.5 rounded border border-zinc-800">
              <button
                onClick={handleDistributeH}
                className="p-1.5 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors flex items-center gap-1"
                title="Distribute Horizontal Spacing"
              >
                <DistributeSpacingHIcon />
                <span className="hidden lg:inline text-[10px] font-medium">Distribute H</span>
              </button>
              <button
                onClick={handleDistributeV}
                className="p-1.5 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors flex items-center gap-1"
                title="Distribute Vertical Spacing"
              >
                <DistributeSpacingVIcon />
                <span className="hidden lg:inline text-[10px] font-medium">Distribute V</span>
              </button>
            </div>
          </>
        )}
      </div>

      <div className="flex items-center gap-2">
        {/* Center Canvas */}
        <button
          onClick={handleCenterCanvasBoth}
          className="px-2 py-1 bg-zinc-800 hover:bg-zinc-700 text-zinc-200 border border-zinc-700 rounded text-[11px] font-medium transition-colors flex items-center gap-1"
          title="Center selection on canvas"
        >
          <Maximize2 className="w-3 h-3 text-blue-400" />
          <span>Center on Page</span>
        </button>

        {/* Group / Ungroup Buttons */}
        {onGroupSelected && selectedElements.length >= 2 && (
          <button
            onClick={onGroupSelected}
            className="px-2 py-1 bg-blue-600/20 hover:bg-blue-600/30 text-blue-300 border border-blue-500/40 rounded text-[11px] font-medium transition-colors flex items-center gap-1"
            title="Group Selected Elements (Ctrl+G)"
          >
            <FolderPlus className="w-3.5 h-3.5 text-blue-400" />
            <span>Group</span>
          </button>
        )}
        {onUngroupSelected && selectedElements.some(e => Boolean(e.groupId)) && (
          <button
            onClick={onUngroupSelected}
            className="px-2 py-1 bg-amber-600/20 hover:bg-amber-600/30 text-amber-300 border border-amber-500/40 rounded text-[11px] font-medium transition-colors flex items-center gap-1"
            title="Ungroup Selected Elements (Ctrl+Shift+G)"
          >
            <FolderMinus className="w-3.5 h-3.5 text-amber-400" />
            <span>Ungroup</span>
          </button>
        )}
      </div>
    </div>
  );
});

export const CanvasAlignmentToolbar: React.FC<CanvasAlignmentToolbarProps> = React.memo(({
  selectedElements,
  canvasWidth,
  canvasHeight,
  onBatchUpdateElements,
  onDuplicateSelected,
  onDeleteSelected,
  onMoveLayerUp,
  onMoveLayerDown,
  onToggleLockSelected,
  onGroupSelected,
  onUngroupSelected
}) => {
  const [alignMode, setAlignMode] = useState<'selection' | 'canvas'>('canvas');
  const [position, setPosition] = useState<{ x: number; y: number } | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const dragRef = useRef<{ startX: number; startY: number; initialX: number; initialY: number } | null>(null);
  const toolbarRef = useRef<HTMLDivElement>(null);

  if (selectedElements.length === 0) return null;

  const handlePointerDownDrag = (e: React.PointerEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (!toolbarRef.current) return;

    const rect = toolbarRef.current.getBoundingClientRect();
    const currX = position ? position.x : rect.left;
    const currY = position ? position.y : rect.top;

    if (!position) {
      setPosition({ x: rect.left, y: rect.top });
    }

    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      initialX: currX,
      initialY: currY
    };
    setIsDragging(true);

    const handlePointerMove = (moveEvt: PointerEvent) => {
      if (!dragRef.current) return;
      const dx = moveEvt.clientX - dragRef.current.startX;
      const dy = moveEvt.clientY - dragRef.current.startY;
      setPosition({
        x: Math.max(10, Math.min(window.innerWidth - 300, dragRef.current.initialX + dx)),
        y: Math.max(10, Math.min(window.innerHeight - 80, dragRef.current.initialY + dy))
      });
    };

    const handlePointerUp = () => {
      setIsDragging(false);
      dragRef.current = null;
      window.removeEventListener('pointermove', handlePointerMove);
      window.removeEventListener('pointerup', handlePointerUp);
    };

    window.addEventListener('pointermove', handlePointerMove);
    window.addEventListener('pointerup', handlePointerUp);
  };

  const handleResetPosition = (e: React.MouseEvent) => {
    e.stopPropagation();
    setPosition(null);
    setIsPinned(false);
  };

  const targetMode = selectedElements.length === 1 ? 'canvas' : alignMode;
  const cWidth = canvasWidth || 300;
  const cHeight = canvasHeight || 200;

  // Alignment Handlers
  const handleAlignLeft = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => { updatesMap[el.id] = { x: 0 }; });
    } else {
      const minX = Math.min(...selectedElements.map(e => e.x));
      selectedElements.forEach(el => { updatesMap[el.id] = { x: minX }; });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignCenterH = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => {
        const w = el.width || 100;
        updatesMap[el.id] = { x: Math.round((cWidth - w) / 2) };
      });
    } else {
      const minX = Math.min(...selectedElements.map(e => e.x));
      const maxX = Math.max(...selectedElements.map(e => e.x + (e.width || 100)));
      const centerX = minX + (maxX - minX) / 2;
      selectedElements.forEach(el => {
        const w = el.width || 100;
        updatesMap[el.id] = { x: Math.round(centerX - w / 2) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignRight = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => {
        const w = el.width || 100;
        updatesMap[el.id] = { x: Math.round(cWidth - w) };
      });
    } else {
      const maxX = Math.max(...selectedElements.map(e => e.x + (e.width || 100)));
      selectedElements.forEach(el => {
        const w = el.width || 100;
        updatesMap[el.id] = { x: Math.round(maxX - w) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignTop = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => { updatesMap[el.id] = { y: 0 }; });
    } else {
      const minY = Math.min(...selectedElements.map(e => e.y));
      selectedElements.forEach(el => { updatesMap[el.id] = { y: minY }; });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignMiddleV = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => {
        const h = el.height || 100;
        updatesMap[el.id] = { y: Math.round((cHeight - h) / 2) };
      });
    } else {
      const minY = Math.min(...selectedElements.map(e => e.y));
      const maxY = Math.max(...selectedElements.map(e => e.y + (e.height || 100)));
      const centerY = minY + (maxY - minY) / 2;
      selectedElements.forEach(el => {
        const h = el.height || 100;
        updatesMap[el.id] = { y: Math.round(centerY - h / 2) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleAlignBottom = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      selectedElements.forEach(el => {
        const h = el.height || 100;
        updatesMap[el.id] = { y: Math.round(cHeight - h) };
      });
    } else {
      const maxY = Math.max(...selectedElements.map(e => e.y + (e.height || 100)));
      selectedElements.forEach(el => {
        const h = el.height || 100;
        updatesMap[el.id] = { y: Math.round(maxY - h) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleDistributeH = () => {
    const sorted = [...selectedElements].sort((a, b) => a.x - b.x);
    const updatesMap: Record<string, Partial<VdpElement>> = {};

    if (targetMode === 'canvas') {
      const sumWidth = sorted.reduce((acc, el) => acc + (el.width || 100), 0);
      const freeSpace = cWidth - sumWidth;
      const gap = freeSpace / (sorted.length + 1);
      let currX = gap;
      sorted.forEach(el => {
        updatesMap[el.id] = { x: Math.round(currX) };
        currX += (el.width || 100) + gap;
      });
    } else {
      if (sorted.length < 2) return;
      const minX = sorted[0].x;
      const maxRight = sorted[sorted.length - 1].x + (sorted[sorted.length - 1].width || 100);
      const sumWidth = sorted.reduce((acc, el) => acc + (el.width || 100), 0);
      const freeSpace = (maxRight - minX) - sumWidth;
      const gap = freeSpace / (sorted.length - 1);
      let currX = minX;
      sorted.forEach((el, idx) => {
        if (idx === 0) updatesMap[el.id] = { x: minX };
        else if (idx === sorted.length - 1) updatesMap[el.id] = { x: maxRight - (el.width || 100) };
        else updatesMap[el.id] = { x: Math.round(currX) };
        currX += (el.width || 100) + gap;
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleDistributeV = () => {
    const sorted = [...selectedElements].sort((a, b) => a.y - b.y);
    const updatesMap: Record<string, Partial<VdpElement>> = {};

    if (targetMode === 'canvas') {
      const sumHeight = sorted.reduce((acc, el) => acc + (el.height || 100), 0);
      const freeSpace = cHeight - sumHeight;
      const gap = freeSpace / (sorted.length + 1);
      let currY = gap;
      sorted.forEach(el => {
        updatesMap[el.id] = { y: Math.round(currY) };
        currY += (el.height || 100) + gap;
      });
    } else {
      if (sorted.length < 2) return;
      const minY = sorted[0].y;
      const maxBottom = sorted[sorted.length - 1].y + (sorted[sorted.length - 1].height || 100);
      const sumHeight = sorted.reduce((acc, el) => acc + (el.height || 100), 0);
      const freeSpace = (maxBottom - minY) - sumHeight;
      const gap = freeSpace / (sorted.length - 1);
      let currY = minY;
      sorted.forEach((el, idx) => {
        if (idx === 0) updatesMap[el.id] = { y: minY };
        else if (idx === sorted.length - 1) updatesMap[el.id] = { y: maxBottom - (el.height || 100) };
        else updatesMap[el.id] = { y: Math.round(currY) };
        currY += (el.height || 100) + gap;
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  // Distribute Objects Handlers
  const handleDistributeObjTop = () => {
    if (selectedElements.length < 3 && targetMode !== 'canvas') return;
    const sorted = [...selectedElements].sort((a, b) => a.y - b.y);
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      const gap = cHeight / (sorted.length + 1);
      sorted.forEach((el, i) => { updatesMap[el.id] = { y: Math.round(gap * (i + 1) - (el.height||100)/2) }; }); // Actually, top means distribute the top edges.
      
      const gapTop = cHeight / sorted.length;
      sorted.forEach((el, i) => { updatesMap[el.id] = { y: Math.round(gapTop * i) }; });
    } else {
      const minY = sorted[0].y;
      const maxY = sorted[sorted.length - 1].y;
      const step = (maxY - minY) / (sorted.length - 1);
      sorted.forEach((el, i) => {
        if (i === 0 || i === sorted.length - 1) return;
        updatesMap[el.id] = { y: Math.round(minY + step * i) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };
  const handleDistributeObjCenterV = () => {
    if (selectedElements.length < 3 && targetMode !== 'canvas') return;
    const sorted = [...selectedElements].sort((a, b) => (a.y + (a.height||100)/2) - (b.y + (b.height||100)/2));
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      const step = cHeight / sorted.length;
      sorted.forEach((el, i) => { updatesMap[el.id] = { y: Math.round((step * i + step/2) - (el.height||100)/2) }; });
    } else {
      const minY = sorted[0].y + (sorted[0].height||100)/2;
      const maxY = sorted[sorted.length - 1].y + (sorted[sorted.length - 1].height||100)/2;
      const step = (maxY - minY) / (sorted.length - 1);
      sorted.forEach((el, i) => {
        if (i === 0 || i === sorted.length - 1) return;
        updatesMap[el.id] = { y: Math.round((minY + step * i) - (el.height||100)/2) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };
  const handleDistributeObjBottom = () => {
    if (selectedElements.length < 3 && targetMode !== 'canvas') return;
    const sorted = [...selectedElements].sort((a, b) => (a.y + (a.height||100)) - (b.y + (b.height||100)));
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      const step = cHeight / sorted.length;
      sorted.forEach((el, i) => { updatesMap[el.id] = { y: Math.round((step * (i+1)) - (el.height||100)) }; });
    } else {
      const minY = sorted[0].y + (sorted[0].height||100);
      const maxY = sorted[sorted.length - 1].y + (sorted[sorted.length - 1].height||100);
      const step = (maxY - minY) / (sorted.length - 1);
      sorted.forEach((el, i) => {
        if (i === 0 || i === sorted.length - 1) return;
        updatesMap[el.id] = { y: Math.round((minY + step * i) - (el.height||100)) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleDistributeObjLeft = () => {
    if (selectedElements.length < 3 && targetMode !== 'canvas') return;
    const sorted = [...selectedElements].sort((a, b) => a.x - b.x);
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      const step = cWidth / sorted.length;
      sorted.forEach((el, i) => { updatesMap[el.id] = { x: Math.round(step * i) }; });
    } else {
      const minX = sorted[0].x;
      const maxX = sorted[sorted.length - 1].x;
      const step = (maxX - minX) / (sorted.length - 1);
      sorted.forEach((el, i) => {
        if (i === 0 || i === sorted.length - 1) return;
        updatesMap[el.id] = { x: Math.round(minX + step * i) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };
  const handleDistributeObjCenterH = () => {
    if (selectedElements.length < 3 && targetMode !== 'canvas') return;
    const sorted = [...selectedElements].sort((a, b) => (a.x + (a.width||100)/2) - (b.x + (b.width||100)/2));
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      const step = cWidth / sorted.length;
      sorted.forEach((el, i) => { updatesMap[el.id] = { x: Math.round((step * i + step/2) - (el.width||100)/2) }; });
    } else {
      const minX = sorted[0].x + (sorted[0].width||100)/2;
      const maxX = sorted[sorted.length - 1].x + (sorted[sorted.length - 1].width||100)/2;
      const step = (maxX - minX) / (sorted.length - 1);
      sorted.forEach((el, i) => {
        if (i === 0 || i === sorted.length - 1) return;
        updatesMap[el.id] = { x: Math.round((minX + step * i) - (el.width||100)/2) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };
  const handleDistributeObjRight = () => {
    if (selectedElements.length < 3 && targetMode !== 'canvas') return;
    const sorted = [...selectedElements].sort((a, b) => (a.x + (a.width||100)) - (b.x + (b.width||100)));
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (targetMode === 'canvas') {
      const step = cWidth / sorted.length;
      sorted.forEach((el, i) => { updatesMap[el.id] = { x: Math.round((step * (i+1)) - (el.width||100)) }; });
    } else {
      const minX = sorted[0].x + (sorted[0].width||100);
      const maxX = sorted[sorted.length - 1].x + (sorted[sorted.length - 1].width||100);
      const step = (maxX - minX) / (sorted.length - 1);
      sorted.forEach((el, i) => {
        if (i === 0 || i === sorted.length - 1) return;
        updatesMap[el.id] = { x: Math.round((minX + step * i) - (el.width||100)) };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const handleCenterCanvasBoth = () => {
    const updatesMap: Record<string, Partial<VdpElement>> = {};
    if (selectedElements.length === 1) {
      const el = selectedElements[0];
      const w = el.width || 100;
      const h = el.height || 100;
      updatesMap[el.id] = {
        x: Math.round((cWidth - w) / 2),
        y: Math.round((cHeight - h) / 2)
      };
    } else {
      const minX = Math.min(...selectedElements.map(e => e.x));
      const maxX = Math.max(...selectedElements.map(e => e.x + (e.width || 100)));
      const minY = Math.min(...selectedElements.map(e => e.y));
      const maxY = Math.max(...selectedElements.map(e => e.y + (e.height || 100)));

      const groupW = maxX - minX;
      const groupH = maxY - minY;
      const targetMinX = (cWidth - groupW) / 2;
      const targetMinY = (cHeight - groupH) / 2;
      const dx = targetMinX - minX;
      const dy = targetMinY - minY;

      selectedElements.forEach(el => {
        updatesMap[el.id] = {
          x: Math.round(el.x + dx),
          y: Math.round(el.y + dy)
        };
      });
    }
    onBatchUpdateElements(updatesMap);
  };

  const allLocked = selectedElements.every(e => e.locked);

  const toolbarContent = (
    <div
      ref={toolbarRef}
      style={
        position
          ? {
              position: 'fixed',
              left: `${position.x}px`,
              top: `${position.y}px`,
              transform: 'none',
              zIndex: 99999,
            }
          : {
              position: 'fixed',
              top: '80px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 99999,
            }
      }
      className={`flex items-center gap-1.5 bg-zinc-900/95 backdrop-blur-md border ${
        isDragging
          ? 'border-blue-500 shadow-blue-500/20 ring-2 ring-blue-500/20'
          : isPinned
          ? 'border-amber-500/80 shadow-amber-500/20'
          : 'border-zinc-700/80'
      } shadow-2xl rounded-lg p-1.5 text-zinc-200 transition-all select-none pointer-events-auto`}
    >
      {/* Drag Handle */}
      <div
        onPointerDown={handlePointerDownDrag}
        className="flex items-center justify-center px-1 py-1 cursor-grab active:cursor-grabbing text-zinc-500 hover:text-zinc-200 hover:bg-zinc-800 rounded transition-colors group"
        title="Click and drag to move toolbar anywhere"
      >
        <GripVertical className="w-4 h-4 group-hover:scale-110 transition-transform" />
      </div>

      <div className="w-[1px] h-10 bg-zinc-800" />
      {/* Mode Selector for Multi-selection */}
      {selectedElements.length > 1 && (
        <div className="flex items-center bg-zinc-950 border border-zinc-800 rounded p-0.5 mr-1 text-[10px]">
          <button
            onClick={() => setAlignMode('selection')}
            className={`px-1.5 py-0.5 rounded transition-colors ${alignMode === 'selection' ? 'bg-blue-600 text-white font-medium' : 'text-zinc-400 hover:text-zinc-200'}`}
            title="Align relative to selected group bounds"
          >
            Selection
          </button>
          <button
            onClick={() => setAlignMode('canvas')}
            className={`px-1.5 py-0.5 rounded transition-colors ${alignMode === 'canvas' ? 'bg-blue-600 text-white font-medium' : 'text-zinc-400 hover:text-zinc-200'}`}
            title="Align relative to full canvas area"
          >
            Canvas
          </button>
        </div>
      )}

            {/* Align Objects Group */}
      <div className="flex flex-col gap-0.5 border border-zinc-800 rounded bg-zinc-950/60 p-0.5">
        <div className="flex items-center gap-0.5">
          <button
            onClick={handleAlignLeft}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors"
            title="Align Left"
          >
            <AlignLeftIcon />
          </button>
          <button
            onClick={handleAlignCenterH}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors"
            title="Align Center (Horizontal)"
          >
            <AlignCenterHIcon />
          </button>
          <button
            onClick={handleAlignRight}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors"
            title="Align Right"
          >
            <AlignRightIcon />
          </button>
        </div>
        <div className="flex items-center gap-0.5">
          <button
            onClick={handleAlignTop}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors"
            title="Align Top"
          >
            <AlignTopIcon />
          </button>
          <button
            onClick={handleAlignMiddleV}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors"
            title="Align Middle (Vertical)"
          >
            <AlignMiddleVIcon />
          </button>
          <button
            onClick={handleAlignBottom}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-300 hover:text-white transition-colors"
            title="Align Bottom"
          >
            <AlignBottomIcon />
          </button>
        </div>
      </div>
      <div className="w-[1px] h-10 bg-zinc-800" />

      {/* Distribute Objects Group */}
      <div className="flex flex-col gap-0.5 border border-zinc-800 rounded bg-zinc-950/60 p-0.5">
        <div className="flex items-center gap-0.5">
          <button
            onClick={handleDistributeObjLeft}
            disabled={selectedElements.length < 3 && targetMode !== 'canvas'}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-white disabled:opacity-30 disabled:hover:bg-transparent transition-colors"
            title="Distribute Left Edges"
          >
            <DistributeLeftIcon />
          </button>
          <button
            onClick={handleDistributeObjCenterH}
            disabled={selectedElements.length < 3 && targetMode !== 'canvas'}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-white disabled:opacity-30 disabled:hover:bg-transparent transition-colors"
            title="Distribute Horizontal Centers"
          >
            <DistributeCenterHIcon />
          </button>
          <button
            onClick={handleDistributeObjRight}
            disabled={selectedElements.length < 3 && targetMode !== 'canvas'}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-white disabled:opacity-30 disabled:hover:bg-transparent transition-colors"
            title="Distribute Right Edges"
          >
            <DistributeRightIcon />
          </button>
        </div>
        <div className="flex items-center gap-0.5">
          <button
            onClick={handleDistributeObjTop}
            disabled={selectedElements.length < 3 && targetMode !== 'canvas'}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-white disabled:opacity-30 disabled:hover:bg-transparent transition-colors"
            title="Distribute Top Edges"
          >
            <DistributeTopIcon />
          </button>
          <button
            onClick={handleDistributeObjCenterV}
            disabled={selectedElements.length < 3 && targetMode !== 'canvas'}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-white disabled:opacity-30 disabled:hover:bg-transparent transition-colors"
            title="Distribute Vertical Centers"
          >
            <DistributeCenterVIcon />
          </button>
          <button
            onClick={handleDistributeObjBottom}
            disabled={selectedElements.length < 3 && targetMode !== 'canvas'}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-white disabled:opacity-30 disabled:hover:bg-transparent transition-colors"
            title="Distribute Bottom Edges"
          >
            <DistributeBottomIcon />
          </button>
        </div>
      </div>
      <div className="w-[1px] h-10 bg-zinc-800" />
      
      {/* Distribute Spacing Group */}
      <div className="flex flex-col gap-0.5 items-center bg-zinc-950/60 border border-zinc-800 rounded p-0.5">
        <button
          onClick={handleDistributeV}
          disabled={selectedElements.length < 3 && targetMode !== 'canvas'}
          className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-white disabled:opacity-30 disabled:hover:bg-transparent transition-colors"
          title="Distribute Vertical Space"
        >
          <DistributeSpacingVIcon />
        </button>
        <button
          onClick={handleDistributeH}
          disabled={selectedElements.length < 3 && targetMode !== 'canvas'}
          className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-white disabled:opacity-30 disabled:hover:bg-transparent transition-colors"
          title="Distribute Horizontal Space"
        >
          <DistributeSpacingHIcon />
        </button>
      </div>
      <div className="w-[1px] h-10 bg-zinc-800" />

      {/* Center Canvas Button */}
      <button
        onClick={handleCenterCanvasBoth}
        className="px-2 py-1 bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 border border-blue-500/40 rounded text-xs font-medium transition-colors flex items-center gap-1"
        title="Center Selection on Canvas"
      >
        <Maximize2 className="w-3 h-3" />
        <span className="text-[10px] hidden sm:inline">Center Canvas</span>
      </button>

      <div className="w-[1px] h-10 bg-zinc-800" />

      {/* Extra Action Buttons */}
      <div className="flex items-center gap-0.5">
        {onGroupSelected && selectedElements.length >= 2 && (
          <button
            onClick={onGroupSelected}
            className="p-1 hover:bg-blue-600/20 hover:text-blue-400 rounded text-zinc-300 transition-colors flex items-center gap-1"
            title="Group Elements (Ctrl+G)"
          >
            <FolderPlus className="w-3.5 h-3.5 text-blue-400" />
            <span className="text-[10px] hidden sm:inline font-medium">Group</span>
          </button>
        )}
        {onUngroupSelected && selectedElements.some(e => Boolean(e.groupId)) && (
          <button
            onClick={onUngroupSelected}
            className="p-1 hover:bg-amber-600/20 hover:text-amber-400 rounded text-zinc-300 transition-colors flex items-center gap-1"
            title="Ungroup Elements (Ctrl+Shift+G)"
          >
            <FolderMinus className="w-3.5 h-3.5 text-amber-400" />
            <span className="text-[10px] hidden sm:inline font-medium">Ungroup</span>
          </button>
        )}
        {onMoveLayerUp && (
          <button
            onClick={onMoveLayerUp}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-zinc-200 transition-colors"
            title="Bring Forward"
          >
            <ArrowUp className="w-3.5 h-3.5" />
          </button>
        )}
        {onMoveLayerDown && (
          <button
            onClick={onMoveLayerDown}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-zinc-200 transition-colors"
            title="Send Backward"
          >
            <ArrowDown className="w-3.5 h-3.5" />
          </button>
        )}
        {onToggleLockSelected && (
          <button
            onClick={onToggleLockSelected}
            className={`p-1 rounded transition-colors ${allLocked ? 'bg-amber-500/20 text-amber-400' : 'hover:bg-zinc-800 text-zinc-400 hover:text-zinc-200'}`}
            title={allLocked ? 'Unlock Selected' : 'Lock Selected'}
          >
            {allLocked ? <Lock className="w-3.5 h-3.5" /> : <Unlock className="w-3.5 h-3.5" />}
          </button>
        )}
        {onDuplicateSelected && (
          <button
            onClick={onDuplicateSelected}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-zinc-200 transition-colors"
            title="Duplicate Selection"
          >
            <Copy className="w-3.5 h-3.5" />
          </button>
        )}
        {onDeleteSelected && (
          <button
            onClick={onDeleteSelected}
            className="p-1 hover:bg-rose-500/20 hover:text-rose-400 rounded text-zinc-400 transition-colors"
            title="Delete Selection"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      {/* Pin & Reset Actions */}
      <div className="w-[1px] h-10 bg-zinc-800" />
      <div className="flex items-center gap-0.5">
        <button
          onClick={() => setIsPinned(!isPinned)}
          className={`p-1 rounded transition-colors ${
            isPinned
              ? 'bg-amber-500/20 text-amber-400 border border-amber-500/40'
              : 'text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800'
          }`}
          title={isPinned ? 'Toolbar is pinned at this location' : 'Pin toolbar at current location'}
        >
          {isPinned ? <Pin className="w-3.5 h-3.5 fill-current" /> : <PinOff className="w-3.5 h-3.5" />}
        </button>
        {position && (
          <button
            onClick={handleResetPosition}
            className="p-1 hover:bg-zinc-800 rounded text-zinc-400 hover:text-zinc-200 transition-colors"
            title="Reset toolbar position to default"
          >
            <RotateCcw className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    </div>
  );

  return createPortal(toolbarContent, document.body);
});
